import React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { Navigate, Outlet } from 'react-router-dom';
import { APP_ROUTES } from '../routes/AppRouter';

export default function AuthorizedRoutes () {
  const { keycloak } = useKeycloak();
  const EXPECTED_ROLES: string[] = [
    'ROLE_WEB_BYTEL_CLIENT_ACCESS_FRONTEND_SUIVI_SAV',
  ];

  const isAuthorized = () => {
    if (keycloak && EXPECTED_ROLES) {
      return EXPECTED_ROLES.some(r => {
        return keycloak.hasResourceRole(r); // keycloak.resourceAccess.bytel-esav-client.roles
      });
    }
    return false;
  };

  return (
    isAuthorized() ? <Outlet/> : <Navigate to={ `${ APP_ROUTES.home }` }/>
  );
}
